import styled from "styled-components";

export const SubHeading = styled.div`
  display: flex;
  margin: 0 12%;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
  }
`;
export const ImageContainer = styled.div`
  width: 3em;
  height: 3em;
  border-radius: 50%;
  overflow: hidden;
  border: 0.15px solid black;
  background: "#D9D9D9";
`;
export const Left = styled.div`
  flex: 1;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: flex;
    justify-content: center;
    margin-bottom: 2em;
  }
`;
